import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@assets/img/icons/stock-empty.svg?react';
import { gameItemOrder } from '@common/constants';
import { type GameItemsType } from '@common/types/common';
import { H2, TextMain } from '@components/Typography/Typography';
import { selectStorageItemBySample } from '@redux/selectors/userSelectors';
import { useAppSelector } from '@redux/store';

import { StorageItem } from '../StorageItem/StorageItem';

interface TabsBodyProps {
  kind: GameItemsType;
}

const TabsBody = forwardRef<HTMLDivElement, TabsBodyProps>(({ kind }, ref) => {
  const { t } = useTranslation();
  const stockList = useAppSelector((state) =>
    selectStorageItemBySample(state, gameItemOrder[kind]),
  );

  return (
    <div ref={ref} className="tabs tabs--sticky w-full flex">
      {stockList && !!stockList.length ? (
        <div className="tabs__body !pt-0 w-full mt-0">
          <div className="tabs__list mt-0 gap-1">
            {stockList
              ?.sort((curr, next) => {
                const orderList = gameItemOrder[kind];

                return (
                  orderList.indexOf(curr.gameItem) -
                  orderList.indexOf(next.gameItem)
                );
              })
              .map((props) => <StorageItem key={props.gameItem} {...props} />)}
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-1 justify-center flex-col items-center">
          <LockIcon className="w-8 h-8 shrink-0 text-white/30 md-h:mb-2 mb-6" />
          <H2 weight="extrabold" className="mb-2">
            {t('Stock is empty')}
          </H2>
          <TextMain
            weight="regular"
            className="leading-1.2 text-white/40 text-center max-w-[14rem]"
          >
            {t('Here your resources are stored, ready for use')}
          </TextMain>
        </div>
      )}
    </div>
  );
});

export default TabsBody;
